import { routeTree } from '../../lib';

const tree = {
    path: '/',
    blog: {
        path: 'blog',
        category: {
            path: 'categoria/:categorySlug',
        },
        search: {
            path: 'search/:searchTerm',
        },
        post: {
            path: ':postSlug',
        },
        news: {
            path: 'news',
            post: {
                path: ':postSlug',
            },
        },
    },
};

export default routeTree<typeof tree>(tree);
